import { SupplyDomainsTable } from './components/SupplyDomainsTable';
import { SupplyTabs } from './SupplyTabs';

export function SupplyDomainsPage() {
  return (
    <>
      <SupplyTabs />
      <main className="page-gutter min-w-0 flex-1 py-4 md:py-6">
        <SupplyDomainsTable />
      </main>
    </>
  );
}
